<template>
  <div class="user-exist-page">
    <h2 class="user-exist-page_headline">It looks like you’re already registered. Please log in to proceed with generation.</h2>
    <div class="user-exist-page_button">
      <Button @click="toForgotPassword" text="modals.forgotPassword" />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import { useStore } from "vuex";

export default {
  name: 'UserExist',
  components: {Button},
  setup() {
    const store = useStore()

    const toForgotPassword = () => {
      store.commit('addModal', 'ForgotPassword')
    }

    return {
      toForgotPassword
    }
  }
}


</script>

<style scoped lang="scss">
.user-exist-page {
  background-color: rgb(22, 22, 22);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  margin: 0 auto;
  padding: 20px 30px;
  border-radius: 15px;
  width: 550px;
  overflow: auto;
  text-align: center;
  &_headline {
    font-size: 22px;
  }
  @media screen and (max-width: 550px) {
    width: 90%;
    margin-bottom: 20px;
  }

  &_button {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
